// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { ActionIcon, Menu, Text } from '@mantine/core';
import { i18n } from '@lingui/core';
import { IconBallpen, IconTrash, IconCopy, IconDots } from '@tabler/icons';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { AgencyTemplateDTO } from '../../../../Types/MessageT';
import { AgencyTemplateS } from '../../../../Service/AgencyTemplateS';
import { openDeleteConfirmModal } from '../../../../Atoms/DeleteConfirmModal';
import { openEditTemplateModal } from './AgencyTemplateModals';

interface Props {
  template: AgencyTemplateDTO;
  onUpdate: (patch: Partial<AgencyTemplateDTO>) => void;
  onDelete: () => void;
}

const TemplateActions: FC<Props> = ({ template, onDelete, onUpdate }) => {
  const { id, name } = template;
  const navigate = useNavigate();

  const copyHandler = async () => {
    const copy = await AgencyTemplateS.copy(id);
    if (copy) {
      navigate(`/settings/agency/message/${copy.id}`);
    }
  };

  const editHandler = () => openEditTemplateModal({ template, onChange: onUpdate });
  const deleteHandler = () => {
    openDeleteConfirmModal({
      title: 'Wirklich löschen?',
      description: (
        <Text>
          Möchtest Du das Vorlage
          <Text span weight="bolder">
            {'  '}
            {name}
            {'  '}
          </Text>
          wirklich löschen?
        </Text>
      ),
      onConfirm: async () => {
        const deleted = await AgencyTemplateS.remove(id);
        if (deleted) {
          onDelete();
        }
        return deleted;
      },
    });
  };

  return (
    <Menu radius="sm" shadow="md" width={130} transition="scale-y" position="bottom-end">
      <Menu.Target>
        <ActionIcon>
          <IconDots />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item icon={<IconCopy size={16} />} onClick={copyHandler}>
          {i18n._('actions.copy')}
        </Menu.Item>
        <Menu.Item icon={<IconBallpen size={16} />} onClick={editHandler}>
          {i18n._('actions.edit')}{' '}
        </Menu.Item>
        <Menu.Item color="red" icon={<IconTrash size={16} />} onClick={deleteHandler}>
          {i18n._('actions.delete')}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default TemplateActions;
